export default "__VITE_ASSET__A4C6p1YE__"